import React from "react";
import { AdminProducerAccountAssignedProducersPreviewTemplate } from "themes/administration/producer/components";

function AdminProducerAccountAssignedProducersPreview(props) {
    return <AdminProducerAccountAssignedProducersPreviewTemplate {...props} />;
}

export default AdminProducerAccountAssignedProducersPreview;
